const ButtonLoader = () => {
  return <div className="dot-falling"></div>;
};
export default ButtonLoader;
